import React, { useEffect, useRef } from 'react';
import './Hero.css';
import jaipurImage from '../assets/images/jaipur.jpg';

const Hero = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    // Debugging: Check if video can play
    const video = videoRef.current;
    if (video) {
      video.addEventListener('loadstart', () => console.log('Video load started'));
      video.addEventListener('canplay', () => console.log('Video can play'));
      video.addEventListener('error', (e) => console.error('Video error:', e));
    }
  }, []);

  return (
    <section 
      className="hero" 
      id="home"
      style={{
        '--mobile-bg-image': `url(${jaipurImage})`
      }}
    >
      {/* Video Background */}
      <div className="hero-video">
        <video 
          ref={videoRef}
          autoPlay 
          muted 
          loop 
          playsInline
          className="hero-video-element"
          preload="auto"
          onError={(e) => console.error('Video failed to load:', e)}
        >
          <source src="/videos/camel-video-2.mp4" type="video/mp4" />
          {/* Fallback for browsers that don't support video */}
          Your browser does not support the video tag.
        </video>
      </div>
      
      {/* Dark overlay for text readability */}
      <div className="hero-overlay"></div>
      
      <div className="container">
        <div className="hero-content">
          <div className="hero-badge">Rajasthan Tour Specialist</div>
          <h1>
            <span className="hero-highlight">Discover the Magic</span>
            <br />
            Where Royal Dreams Come True
          </h1>
          <p className="hero-subtitle">
            Step into a land where every grain of sand tells a story of kings and queens. 
            From majestic palaces that touch the sky to golden dunes that dance with the wind - 
            <strong> your royal adventure begins here!</strong>
          </p>
        </div>
      </div>
    </section>
  );
};

export default Hero;
